/** Alineado con Nest Multer (15 MB/archivo) y nginx /food-api client_max_body_size (40m). */
export const MEASUREMENT_MAX_PHOTOS = 4
export const MEASUREMENT_MAX_FILE_MB = 15
export const MEASUREMENT_MAX_FILE_BYTES = MEASUREMENT_MAX_FILE_MB * 1024 * 1024
export const MEASUREMENT_MAX_TOTAL_MB = 40
export const MEASUREMENT_MAX_TOTAL_BYTES = MEASUREMENT_MAX_TOTAL_MB * 1024 * 1024
export const MEASUREMENT_PHOTO_FORMATS_LABEL = 'JPG, PNG, WebP o HEIC'
export const MEASUREMENT_PHOTO_ACCEPT = 'image/jpeg,image/png,image/webp,image/heic,image/heif,image/jpg,.jpg,.jpeg,.png,.webp,.heic,.heif'

const MIME_OK = /^image\/(jpeg|png|webp|heic|heif|jpg)$/i
const EXT_OK = /\.(jpe?g|png|webp|heic|heif)$/i

export const MEASUREMENT_PHOTO_HINT =
  `Formatos: ${MEASUREMENT_PHOTO_FORMATS_LABEL}. Máximo ${MEASUREMENT_MAX_FILE_MB} MB por foto (hasta ${MEASUREMENT_MAX_PHOTOS}; el total no puede superar ${MEASUREMENT_MAX_TOTAL_MB} MB).`

function fileAllowed(file: File): boolean {
  const mime = String(file.type || '').toLowerCase()
  if (MIME_OK.test(mime)) return true
  return EXT_OK.test(file.name || '')
}

export function validateMeasurementPhotos(files: File[]): string | null {
  if (files.length > MEASUREMENT_MAX_PHOTOS) {
    return `Puedes adjuntar máximo ${MEASUREMENT_MAX_PHOTOS} fotos. Formatos: ${MEASUREMENT_PHOTO_FORMATS_LABEL}.`
  }
  for (const file of files) {
    if (!fileAllowed(file)) {
      return `“${file.name || 'archivo'}” no es un formato válido. Usa ${MEASUREMENT_PHOTO_FORMATS_LABEL} (máx. ${MEASUREMENT_MAX_FILE_MB} MB cada una).`
    }
    if (file.size > MEASUREMENT_MAX_FILE_BYTES) {
      const mb = (file.size / (1024 * 1024)).toFixed(1)
      return `“${file.name || 'foto'}” pesa ${mb} MB. Cada foto debe ser menor a ${MEASUREMENT_MAX_FILE_MB} MB. Formatos: ${MEASUREMENT_PHOTO_FORMATS_LABEL}.`
    }
  }
  const total = files.reduce((sum, f) => sum + (f.size || 0), 0)
  if (total > MEASUREMENT_MAX_TOTAL_BYTES) {
    const mb = (total / (1024 * 1024)).toFixed(1)
    return `Las fotos juntas pesan ${mb} MB. El máximo es ${MEASUREMENT_MAX_TOTAL_MB} MB en total. Reduce el tamaño o sube menos fotos (${MEASUREMENT_PHOTO_FORMATS_LABEL}, máx. ${MEASUREMENT_MAX_FILE_MB} MB c/u).`
  }
  return null
}

export function measurementSaveErrorMessage(err: any): string {
  const status = err?.response?.status
  const raw = err?.response?.data?.message ?? err?.response?.data?.error ?? ''
  const text = Array.isArray(raw) ? raw.join(' ') : String(raw || '')
  const timedOut = err?.code === 'ECONNABORTED' || /timeout/i.test(String(err?.message || ''))
  if (timedOut) {
    return `La subida tardó demasiado. Usa ${MEASUREMENT_PHOTO_FORMATS_LABEL} de menos de ${MEASUREMENT_MAX_FILE_MB} MB cada una (total máx. ${MEASUREMENT_MAX_TOTAL_MB} MB).`
  }
  if (status === 413 || /file too large|payload too large|entity too large/i.test(text)) {
    return `El archivo es demasiado pesado. Cada foto debe pesar menos de ${MEASUREMENT_MAX_FILE_MB} MB y el total menos de ${MEASUREMENT_MAX_TOTAL_MB} MB. Formatos: ${MEASUREMENT_PHOTO_FORMATS_LABEL}.`
  }
  if (/solo imágenes|formato no válido|formato válido/i.test(text)) {
    return `Formato no válido. Usa ${MEASUREMENT_PHOTO_FORMATS_LABEL} (máx. ${MEASUREMENT_MAX_FILE_MB} MB por foto).`
  }
  if (text && !/internal server error|error interno/i.test(text)) return text
  return `No se pudieron guardar las fotos. Deben ser ${MEASUREMENT_PHOTO_FORMATS_LABEL}, menos de ${MEASUREMENT_MAX_FILE_MB} MB cada una y ${MEASUREMENT_MAX_TOTAL_MB} MB en total.`
}
